export default "__VITE_ASSET__B8sJ5bL9__"